import { render, staticRenderFns } from "./InformationListAccordionItem.vue?vue&type=template&id=7614a428&"
import script from "./InformationListAccordionItem.vue?vue&type=script&lang=js&"
export * from "./InformationListAccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports